/** The allowable values for a candidate's recruiting status. */
export const CandidateRecruitingStatuses = [
    'Final Stages',
    'Actively Recruiting',
    'Opportunistic',
    'Holding Out',
    'Not Recruiting',
    'Do Not Call',
    'Red Flag',
    'No Status',
] as const

/** A derived type for referencing a specific candidate recruiting status. */
export type CandidateRecruitingStatus =
    (typeof CandidateRecruitingStatuses)[number]

/** A type guard for identifying if a string is a valid candidate recruiting status. */
export function isCandidateRecruitingStatus(
    value: string
): value is CandidateRecruitingStatus {
    return CandidateRecruitingStatuses.includes(
        value as CandidateRecruitingStatus
    )
}
